import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";

/**
 * The LoginForm component provides a form for users to input their credentials.
 * @param {string} userId - The user's ID.
 * @param {string} password - The user's password.
 * @param {string} otp - The 2FA OTP code.
 * @param {(value: string) => void} setUserId - A function to update the user's ID state.
 * @param {(value: string) => void} setPassword - A function to update the password state.
 * @param {(value: string) => void} setOtp - A function to update the OTP code state.
 */
const LoginForm = ({ userId, password, otp, setUserId, setPassword, setOtp }) => {
  return (
    <Grid container alignItems={"center"} justifyContent={"center"} spacing={3}>
      <Grid size={{ sm: 12, md: 4 }}>
        <TextField
          label="User ID"
          variant="standard"
          value={userId}
          onChange={(event) => setUserId(event.target.value)}
          margin="normal"
          fullWidth
        />
      </Grid>
      <Grid size={{ sm: 12, md: 4 }}>
        <TextField
          type="password"
          label="Password"
          variant="standard"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          margin="normal"
          fullWidth
        />
      </Grid>
      <Grid size={{ sm: 12, md: 4 }}>
        <TextField
          label="2FA OTP"
          variant="standard"
          value={otp}
          onChange={(event) => setOtp(event.target.value)}
          margin="normal"
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default LoginForm;
